// @ts-nocheck
const validateCPF = (cpf: string) => {
  let number;
  let digits;
  let sum;
  let i;
  let result;
  let equalDigits;

  equalDigits = 1;
  if (cpf.length < 11) return false;
  for (i = 0; i < cpf.length - 1; i += 1)
    if (cpf.charAt(i) !== cpf.charAt(i + 1)) {
      equalDigits = 0;
      break;
    }
  if (!equalDigits) {
    number = cpf.substring(0, 9);
    digits = cpf.substring(9);
    sum = 0;
    for (i = 10; i > 1; i -= 1) sum += number.charAt(10 - i) * i;
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(0), 10)) return false;
    number = cpf.substring(0, 10);
    sum = 0;
    for (i = 11; i > 1; i -= 1) sum += number.charAt(11 - i) * i;
    result = sum % 11 < 2 ? 0 : 11 - (sum % 11);
    if (result !== parseInt(digits.charAt(1), 10)) return false;
    return true;
  }
  return false;
};

export default validateCPF;
